import { getSupabaseClient } from './supabaseClient'

export type LeadNotifyPayload = {
  source: string
  full_name?: string | null
  email?: string | null
  phone?: string | null
  message?: string | null
  payload?: Record<string, unknown>
}

/**
 * Notify the team of a new lead by invoking the Supabase Edge Function `notify-lead`:
 * - Sends email via Resend to cassi@hudsonmyhome.com, joe@blueogroup.com, mitch@hudsonmyhome.com, accounts@themakerai.com.
 * - Forwards the same payload to GoHighLevel (workflow webhook) with `lead_type` = `source` and human-readable `lead_type_label`.
 * For maintenance_quiz / archetype_quiz, the function also emails the homeowner when applicable.
 * Fire-and-forget from the caller's perspective; failures are logged only.
 *
 * NOTE: The GHL handoff happens server-side inside the Supabase function so we don't
 * double-post from the browser. Do not add a second client-side webhook call here.
 */
export async function notifyLeadByEmail(data: LeadNotifyPayload): Promise<void> {
  try {
    const supabase = getSupabaseClient()
    const { data: result, error } = await supabase.functions.invoke('notify-lead', {
      body: {
        source: data.source,
        full_name: data.full_name ?? undefined,
        email: data.email ?? undefined,
        phone: data.phone ?? undefined,
        message: data.message ?? undefined,
        payload: data.payload ?? {},
      },
    })

    if (error) {
      console.warn('[notifyLead] Edge function error:', error.message, error)
      return
    }
    if (result && typeof result === 'object' && 'error' in result && result.error) {
      console.warn(
        '[notifyLead] Resend/function returned error:',
        (result as { error: string; details?: string }).error,
        (result as { details?: string }).details,
      )
    }
  } catch (e) {
    console.warn('[notifyLead] Failed to send lead notification:', e)
  }
}
